import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const EmbeddedAdminSupplyOutlookReportConfig = {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/supply-outlook-report', component: FuseLoadable({ loader: () => import('./ViewEmbeddedSupplyOutlookReportApp') }) }],
};

export default EmbeddedAdminSupplyOutlookReportConfig;
